import { ApplicationConfig, LOCALE_ID, provideBrowserGlobalErrorListeners, provideZoneChangeDetection } from '@angular/core';
import { provideRouter, withComponentInputBinding, withInMemoryScrolling } from '@angular/router';
import { routes } from './app.routes';
import { provideHttpClient, withInterceptors, withXhr } from '@angular/common/http';
import { ErrorInterceptor } from './interceptors/error.interceptor';
import { provideKeycloakAngular } from './config/keycloak.config';
import { mockInterceptor } from './interceptors/mock.interceptor';
import { registerLocaleData } from '@angular/common';
import localeIt from '@angular/common/locales/it';
import { tokenInterceptor } from './interceptors/token.interceptor';
registerLocaleData(localeIt);

export const appConfig: ApplicationConfig = {
  providers: [
    { provide: LOCALE_ID, useValue: "it-IT"},
    provideKeycloakAngular(),
    provideBrowserGlobalErrorListeners(),
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideHttpClient(withXhr(), withInterceptors([tokenInterceptor,ErrorInterceptor,mockInterceptor])),
    provideRouter(routes,
      withComponentInputBinding(),
      withInMemoryScrolling({ scrollPositionRestoration: 'enabled' })
    )
  ]
};
